module.exports = __webpack_public_path__ + "9e1878a31c2835fc5a00b18e63f9dd67.svg";